<div class="flex h-full flex-col bg-slate-900 text-slate-100">
  <div class="border-b border-white/10 px-5 py-4">
    <img
      src="/dhs-logo-vertical.png"
      alt="DeKalb County Human Services Office of Violence Prevention"
      class="h-20 w-auto m-auto"
    />
  </div>

  <div class="flex-1 overflow-y-auto px-3 py-4">
    <nav class="space-y-1">
      @for (item of navItems(); track item.route) {
        <a
          [routerLink]="item.route"
          routerLinkActive="bg-white/10 text-white"
          class="flex items-center rounded-xl px-3 py-2.5 text-sm font-medium text-slate-300 transition hover:bg-white/10 hover:text-white"
        >
          {{ item.label }}
        </a>
      }
    </nav>
  </div>

  <div class="border-t border-white/10 px-3 py-4">
    <button
      type="button"
      (click)="logout()"
      [disabled]="logoutInProgress()"
      class="w-full rounded-xl border border-white/10 px-3 py-2.5 text-left text-sm font-medium text-slate-300 transition hover:bg-white/10 hover:text-white"
    >
      @if (logoutInProgress()) {
        Signing out...
      } @else {
        Log Out
      }
    </button>
  </div>
</div>